import { createFileRoute } from '@tanstack/react-router';
import { Launcher } from '@/features/portal/launcher';

export const Route = createFileRoute('/_app/')({
  component: Launcher,
});
